import { useQuery } from "@tanstack/react-query";

import { listManagingPrompts } from "../api/ChatApi";

const FIVE_MINUTES = 5 * 60 * 1000;

/**
 * Fetches and caches the managing prompt catalog for the current workspace.
 *
 * Caching strategy: the catalog only changes when the prompt library is
 * redeployed, so a 5-minute stale window is safe and matches the spec.
 */
export function useManagingPrompts(
  workspaceId: string | undefined | null,
  opts?: { recordId?: string | null; activityId?: string | null }
) {
  const recordId = opts?.recordId ?? null;
  const activityId = opts?.activityId ?? null;
  return useQuery({
    queryKey: ["crm-chat", "managing-prompts", workspaceId, recordId, activityId],
    queryFn: () =>
      listManagingPrompts(workspaceId as string, {
        recordId: recordId ?? undefined,
        activityId: activityId ?? undefined,
      }),
    enabled: Boolean(workspaceId),
    staleTime: FIVE_MINUTES,
    refetchOnWindowFocus: false,
  });
}
